import React, { useEffect, useState } from 'react';
import _get from 'lodash/get';
import { client } from 'cccisd-apollo';
import IconUp from 'cccisd-icons/arrow-up2';
import {
    SecureMessagingSingleConversation,
    SecureMessagingMultipleConversations,
} from 'cccisd-laravel-secure-messaging';
import Loader from 'cccisd-loader';
import messageParticipantsQuery from './messageParticipants.graphql';
import style from './style.css';

const Appdefs = window.cccisd.appDefs;
const Fortress = window.cccisd.fortress;

function TfhMessagingParent() {
    const [allCoaches, setAllCoaches] = useState(null);
    const parent = {
        id: Fortress.user.pawnId,
        username: Fortress.user.username,
        firstName: Fortress.user.firstName,
        lastName: Fortress.user.lastName,
    };

    useEffect(() => {
        async function getChatParticipants() {
            const resp = await client.query({ query: messageParticipantsQuery });
            let instructors = _get(resp, 'data.groups.tfhClass.targetedByPawns.tfhInstructorList', []) || [];
            setAllCoaches(instructors.map(instructor => ({ id: instructor.pawn.pawnId, ...instructor.user })));
        }

        getChatParticipants();
    }, []);

    function scrollToTop() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }

    if (allCoaches === null) {
        return <Loader loading />;
    }

    if (!Array.isArray(allCoaches) || allCoaches.length === 0) {
        let coachLabel = 'TFH Coach';
        try {
            coachLabel = Appdefs.pawn.roles.find(r => r.handle === 'tfhInstructor').label;
        } catch (e) {
            coachLabel = 'TFH Coach';
        }
        return (
            <div className="alert alert-info">
                <p className="mb-0">Messaging is not available because you have no {coachLabel} assigned.</p>
            </div>
        );
    }

    return (
        <div>
            {allCoaches.length > 1 ? (
                <SecureMessagingMultipleConversations primaryParticipant={parent} anotherParticipants={allCoaches} />
            ) : (
                <SecureMessagingSingleConversation primaryParticipant={parent} anotherParticipant={allCoaches[0]} />
            )}

            <div className={style.backToTop}>
                <button className="btn btn-link" type="button" onClick={scrollToTop}>
                    <IconUp spaceRight />
                    Scroll to Top
                </button>
            </div>
        </div>
    );
}

export default TfhMessagingParent;
